import React from "react";
import S from "./MainImageBlock.styled";
import { IWPImage, IWPLink } from "@/src/types";
import { toGatsbyImage } from "@/src/helpers";
import Button from "@/components/global-components/Button";
import Tag from "@/components/global-components/Tag";

export interface Props {
  tag: string;
  title: string;
  text: string;
  link: IWPLink;
  secondLink: IWPLink;
  image: IWPImage;
  mediaPosition: string;
  backgroundColor: string;
}

const MainImageBlock: React.FC<Props> = ({
  tag,
  text,
  title,
  link,
  secondLink,
  image,
  mediaPosition,
  backgroundColor,
}) => {
  const imageData = toGatsbyImage(image);

  return (
    <S.Inner $mediaPosition={mediaPosition} $bgColor={backgroundColor}>
      {imageData && <S.Image image={imageData} alt={image.altText || ""} />}
      <S.ContentWrapper>
        {tag && <Tag tag={tag} />}
        {title && <S.Title>{title}</S.Title>}
        {text && <S.Text>{text}</S.Text>}
        {link && (
          <S.BtnWrapper>
            <Button link={link} type="primary" arrow />
            {secondLink && <Button link={secondLink} type="primary" />}
          </S.BtnWrapper>
        )}
      </S.ContentWrapper>
    </S.Inner>
  );
};

export default MainImageBlock;
